import { DataTable } from "simple-datatables";
import { checkSize } from "./utils.mjs";
/***** Begin reusable functions *****/

// Initialize DataTable plugin to enable searching, sorting, and pagination
function initializeDataTable() {

  dataTable = new DataTable(".openings__list", {
    sortable: false, // Sorting is actually being used with some custom logic. See the triggerSort() function.
    searchable: false, // Searching is actually being used with some custom logic. See the triggerFilter() function.
    perPageSelect: false,
    labels: {
      noRows:
        "Sorry, we couldn't find any openings that match your search criteria. Please change the filters and try again.",
    },
    classes: {
			paginationList: "datatable-pagination-list pagination",
		},
  });

  if (!tableFirstInitialized) {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    let urlValue = params.location;
    if (urlValue !== null) {
      // convert url friendly value into the checkbox value
      let checkboxValue = urlValue;
      switch (urlValue) {
        case "atmore":
        case "wca":
        case "WCA":
          checkboxValue = "Atmore";
          break;
        case "wetumpka":
        case "wcw":
        case "WCW":
          checkboxValue = "Wetumpka";
          break;
        case "montgomery":
        case "wcm":
        case "WCM":
          checkboxValue = "Montgomery";
          break;
        case "miami":
        case "mcc":
        case "MCC":
          checkboxValue = "Magic City Casino";
          break;
        case "chicago":
        case "wcc":
        case "WCC":
          checkboxValue = "Chicago Southland";
          break;
        case "bethlehem":
        case "wcb":
        case "WCB":
          checkboxValue = "Bethlehem";
          break;
        case "hospitality":
        case "wch":
        case "WCH":
          checkboxValue = "Wind Creek Hospitality";
          break;
        default:
          // Just in case any new properties get added in the future, it will
          // at least work with an exact match so a custom mapping doesn't have
          // to be immediately added here every time
          checkboxValue = urlValue;
          break;
      }

      let prefilter = document.querySelector(
        `[name="filterLocation"][value="${checkboxValue}"]`
      );
      if (prefilter) {
        prefilter.checked = true;
        tableFirstInitialized = true;
        triggerFilter();
      }
    }
  }

  dataTable.on("datatable.init", function () {
    triggerSort();
    tableFirstInitialized = true;
  });
}

// Map custom sort options to the correct columns
function triggerSort(val = "") {
  if (!val) {
    val = "datepostedrecent";
  }

  dataTable.page(1); // Since the sort order is changing, jump back to page one

  switch (val) {
    case "jobtitleaz":
      dataTable.columns.sort(0, "asc");
      break;
    case "jobtitleza":
      dataTable.columns.sort(0, "desc");
      break;
    case "datepostedrecent":
      dataTable.columns.sort(6, "desc");
      break;
    case "datepostedoldest":
      dataTable.columns.sort(6, "asc");
      break;
    case "dateclosingsoonest":
      dataTable.columns.sort(7, "asc");
      break;
    case "dateclosinglatest":
      dataTable.columns.sort(7, "desc");
      break;
    default:
      dataTable.columns.sort(6, "desc");
      break;
  }
}

function triggerFilter() {
  // Get a list of all the checked filters
  var formData = new FormData(document.querySelector(".filter__filters"));
  const searchBox = document.getElementById("filterSearch");

  const queries = [
    {
      terms: formData.getAll("filterLocation"),
      columns: [1],
    },
    {
      terms: formData.getAll("filterDepartment"),
      columns: [2],
    },
    {
      terms: formData.getAll("filterType"),
      columns: [3],
    },
  ];
  if (searchBox.value !== "") {
    queries.push({
      terms: [searchBox.value],
    });
  }

  dataTable.multiSearch(queries);
}
/***** End reusable functions *****/

let careersTable = document.querySelector(".openings__list");
let tableFirstInitialized = false;

if (careersTable) {
  var dataTable;
  var sortSelector = document.getElementById("sortBySelect");

  initializeDataTable();

  // Event handler for when the user changes which column to sort by
  const sortOptions = sortSelector.querySelectorAll(".sort__link");
  sortOptions.forEach((option) => {
    option.addEventListener("click", (event) => {
      event.preventDefault();
      sortOptions.forEach((option) => {
        option.classList.remove("active");
      });
      option.classList.add("active");
      // sortSelector.value = option.dataset.sort;
      triggerSort(option.dataset.sort);
    });
  });

  // Event handler for when the user submits the search form
  document
    .querySelector(".filter__search")
    .addEventListener("submit", (event) => {
      event.preventDefault();

      triggerFilter();
    });

  // Event handler for when the user changes the value of our custom search box
  document
    .querySelector(".filter__search")
    .addEventListener("input", (event) => {
      event.preventDefault();

      triggerFilter();
    });

  // Event handler for when the clicks the clear filter button
  document
    .querySelector("[data-clear-filters]")
    .addEventListener("click", (event) => {
      document.getElementById("filterSearch").value = "";

      let filterCheckboxes = document.querySelectorAll(
        '[name="filterLocation"], [name="filterDepartment"], [name="filterType"]'
      );
      filterCheckboxes.forEach((element) => {
        element.checked = false;
      });

      filterCheckboxes[0].dispatchEvent(new Event("change"));
      // Trigger a fake change event on a checkbox so our event handler runs
    });

  // Filter the data when the user toggles one of the filter checkboxes
  // Filtering is not a native feature of the DataTable plugin, so we're doing some custom logic here
  document
    .querySelectorAll(
      '[name="filterLocation"], [name="filterDepartment"], [name="filterType"]'
    )
    .forEach((element) => {
      element.addEventListener("change", (event) => {
        event.preventDefault();
        triggerFilter();
      });
    });
}

//Close all accordion items on smaller screens
window.addEventListener("load", function () {
  if (checkSize(768)) {
    const accItems = document.querySelectorAll(
      ".filter__filters .accordion-item"
    );
    accItems.forEach((item) => {
      const btn = item.querySelector(".accordion-button");
      const content = item.querySelector(".accordion-collapse");
      btn.classList.add("collapsed");
      btn.setAttribute("aria-expanded", "false");
      content.classList.remove("show");
    });
  }
});
